/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isroledefault2Inputs */

const en_entity_isroledefault2 = /** @type {(inputs: Entity_Isroledefault2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Default Role`)
};

const de_entity_isroledefault2 = /** @type {(inputs: Entity_Isroledefault2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Standardrolle`)
};

/**
* | output |
* | --- |
* | "Ist Default Role" |
*
* @param {Entity_Isroledefault2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isroledefault2 = /** @type {((inputs?: Entity_Isroledefault2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isroledefault2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isroledefault2(inputs)
	return de_entity_isroledefault2(inputs)
});
export { entity_isroledefault2 as "entity_isRoleDefault" }